/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ActionType {
    Add = 'ADD',
    Blacklist = 'BLACKLIST',
    Delete = 'DELETE',
    Deploy = 'DEPLOY',
    Forgetpassword = 'FORGETPASSWORD',
    Login = 'LOGIN',
    Logout = 'LOGOUT',
    Resetpassword = 'RESETPASSWORD',
    Start = 'START',
    Stop = 'STOP',
    Update = 'UPDATE',
    Upgrade = 'UPGRADE'
}

export function ActionTypeFromJSON(json: any): ActionType {
    return ActionTypeFromJSONTyped(json, false);
}

export function ActionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActionType {
    return json as ActionType;
}

export function ActionTypeToJSON(value?: ActionType | null): any {
    return value as any;
}

